import {
    setCookie,
    initializeMap,
    initMenuTrigger,
    initOpenInNewTab,
    aosConfig,
    addScollClass,
    addParalax,
    addFancyboxFixForGallery,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews
} from './functions';

import gsap from "gsap";


const mainApp = () => {



    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    initOpenInNewTab();

    // init AOS animation config
    aosConfig();

    // add scroll class to body  
    addScollClass('0px');

    // add paralax to element
    //addParalax('.paralax');



    //fix gallery id for slideshow
    //addFancyboxFixForGallery('.blocks-gallery-grid');

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    //googleMapInit();


    //initLoadNews();


}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {
        //rotator and sliders
        if ($('.rotatorTop').length > 0) {
            $('.rotatorTop').slick({
                infinite: true,
                arrows: true,
                dots: false,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                autoplaySpeed: 5000,
                fade: true,
                cssEase: 'linear'
            });
        }

        if ($('.wp-block-gallery').length > 0) {
            $('.wp-block-gallery').each(function (i) {
                let newGallery = $('<div class="newGallery"><div class="newGallery__slider slickSliderUi"></div></div>');
                let tempItem = '';
                $(this).find('.blocks-gallery-item figure').each(function (index) {

                    let newItem = $('<div class="newGallery__slide">' + $(this).html() + '</div>');
                    newGallery.find('.newGallery__slider').append(newItem);

                });
                $(this).before(newGallery);
                var idGal = 'gal' + (Math.floor(Math.random() * 100));
                newGallery.find('a').each(function () {
                    $(this).attr('data-fancybox', idGal);
                });
                $(this).remove();

            });

            $('.newGallery__slider').slick({
                infinite: true,
                arrows: true,
                dots: false,
                autoplay: true,
                speed: 500,
                autoplaySpeed: 10000,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });

        }



        //fancybox
        $(".blocks-gallery-item a, .fancybox, .wp-block-image a").fancybox({
            'loop': true,
            'margin': [44, 0],
            'gutter': 50,
            'keyboard': true,
            'arrows': true,
            'infobar': false,
            'toolbar': true,
            'buttons': ["slideShow", "fullScreen", "close"],
            'idleTime': 4,
            'protect': false,
            'modal': false,
            'animationEffect': "fade",
            'animationDuration': 600,
            'transitionEffect': "fade",
            'transitionDuration': 800,
        });

        $(".newGallery__slide a").fancybox({
            loop: true,
            margin: [44, 0],
            gutter: 50,
            keyboard: true,
            arrows: true,
            infobar: false,
            toolbar: true,
            buttons: ["slideShow", "fullScreen", "close"],
            idleTime: 4,
            protect: false,
            modal: false,
            animationEffect: false,
            animationDuration: 600,
            transitionEffect: "fade",
            transitionDuration: 800,
            //autoFocus: false,
            backFocus: false,

        });



    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);



